import { ToggleGroup, ToggleGroupItem } from '@/components/toggleGroup'

interface Props {
    value: string
    onChange: (value: string) => void
}

const values = ['5m', '15m', '1h', '6h', '24h', '7d', '14d', '30d']

export default function HistoryToggle({ value, onChange }: Props) {
    return (
        <ToggleGroup
            type="single"
            value={value.toString()}
            onValueChange={v => {
                if (v) {
                    onChange(v)
                }
            }}
        >
            {values.map(v => (
                <ToggleGroupItem value={v} key={v} aria-label={`Toggle ${v} days`} size={'sm'}>
                    {v}
                </ToggleGroupItem>
            ))}
        </ToggleGroup>
    )
}
